(function () {
  // Pause offscreen animations to save battery
  var animated = document.querySelectorAll('.bs-hero__orb, .bs-brands__track');
  if (animated.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.style.animationPlayState = e.isIntersecting ? 'running' : 'paused';
      });
    }, { rootMargin: '100px' });
    animated.forEach(function (t) { obs.observe(t); });
  }

  // Bundles: normalize data-state so exactly one panel is expanded on load.
  // Guards against merchant footgun — reordering blocks or checking "featured" on
  // zero/multiple panels would otherwise break the CSS hover-out state.
  document.querySelectorAll('[data-bs-bundle-strip]').forEach(function (strip) {
    var panels = strip.querySelectorAll('[data-bs-bundle-panel]');
    if (!panels.length) return;
    var expanded = strip.querySelectorAll('[data-bs-bundle-panel][data-state="expanded"]');
    if (expanded.length === 0) {
      panels[0].setAttribute('data-state', 'expanded');
    } else if (expanded.length > 1) {
      expanded.forEach(function (p, i) {
        p.setAttribute('data-state', i === 0 ? 'expanded' : 'collapsed');
      });
    }
  });

  // Bundle accordion: click-to-expand for touch and keyboard
  var panels = document.querySelectorAll('[data-bs-bundle-panel]');
  panels.forEach(function (panel) {
    var activate = function (e) {
      if (e.target.closest('a')) return; // don't hijack CTA clicks
      var strip = panel.closest('[data-bs-bundle-strip]');
      if (!strip) return;
      strip.querySelectorAll('[data-bs-bundle-panel]').forEach(function (p) {
        p.setAttribute('data-state', p === panel ? 'expanded' : 'collapsed');
      });
    };
    panel.addEventListener('click', activate);
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(e); }
    });
  });
})();
